const CTA_CLASS =
    'flex h-14 w-full items-center justify-center rounded-full bg-[#181818] text-xl font-medium tracking-[-0.02em] text-[#f3f3f3] shadow-[0_0.1875rem_0.8125rem_0_rgba(0,0,0,0.25),0_1.25rem_2.125rem_0_rgba(0,0,0,0.25)] transition-colors hover:bg-[#2c2c2c]';

export interface DownloadGateSuccessProps {
    /** File name shown under the heading, when the intent carried one. */
    fileName?: string;
    /** Thumbnail of the file being downloaded. */
    fileImage?: string;
    /**
     * Starts the download. Must run from this click: browsers only allow
     * `window.open` inside a user gesture, and the auth round-trip consumed the
     * original one — which is why the design puts a button here rather than
     * downloading on arrival.
     */
    onDownload: () => void;
    /** Continue into the normal onboarding flow. */
    onExplore: () => void;
}

/**
 * Success step of the download gate: the account exists, the file is unlocked,
 * and one press starts it.
 */
export const DownloadGateSuccess = ({
    fileName,
    fileImage,
    onDownload,
    onExplore,
}: DownloadGateSuccessProps) => (
    <div className="mx-auto my-auto flex w-full max-w-[22.6875rem] flex-col">
        <h2 className="m-0 text-[2.0625rem] leading-[2.125rem] font-medium tracking-[-0.02em] text-[#181818]">
            You&rsquo;re in!
            <br />
            your file&rsquo;s ready to download.
        </h2>
        <p className="m-0 mt-5 text-[1.0625rem] leading-snug tracking-[-0.02em] text-[#828282]">
            Next time your file will download instantly.
        </p>
        {fileImage ? (
            <img
                src={fileImage}
                alt=""
                className="mx-auto mt-8 h-[11.5rem] w-auto rounded-md object-contain"
            />
        ) : null}
        {fileName ? (
            <p className="m-0 mt-4 text-center text-[0.9375rem] text-[#656565]">
                {fileName}
            </p>
        ) : null}
        <button
            type="button"
            onClick={onDownload}
            className={`mt-8 ${CTA_CLASS}`}
        >
            Download File
        </button>
        <button
            type="button"
            onClick={onExplore}
            className="mt-4 text-center text-[1.0625rem] tracking-[-0.02em] text-[#44443f]"
        >
            Explore my unlocked ArchiPro features
        </button>
    </div>
);
